var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import LocationBold from './micro/LocationBold';
import HorizontalDivisor from './micro/HorizontalDivisor';
import Address from './micro/Address';
import './DirectoryList.scss';
var data = {
    theme: '#005f9e',
};
var defaultProps = {
    data: data,
};
var themes = [
    { backgroundColor: '#343741', color: '#ffffff' },
    { backgroundColor: '#005f9e', color: '#ffffff' },
    { backgroundColor: '#d8dcdb', color: '#343741' },
    { backgroundColor: '#ffffff', color: '#005f9e' }, // White
];
var DirectoryList = function (_a) {
    var _b = _a.data, headline = _b.headline, theme = _b.theme, regions = _b.regions;
    var columns = window.visualViewport.width < 768
        ? 1
        : window.visualViewport.width < 1440
            ? 2
            : 3;
    var chosenTheme = themes[1];
    var themeIndex = themes.findIndex(function (_a) {
        var backgroundColor = _a.backgroundColor;
        return backgroundColor.toLowerCase() === theme.toLowerCase();
    });
    if (themeIndex >= 0) {
        chosenTheme = themes[themeIndex];
    }
    var renderList = function (locationsList, oneKey) {
        var ulArray = [];
        for (var i = 0; i < locationsList.length; i += columns) {
            var index = i;
            var limit = index + columns;
            var liArray = [];
            while (index < limit) {
                var location_1 = locationsList[index];
                if (location_1) {
                    liArray.push(_jsxs("li", __assign({ className: "directory-list__location mb-6 md:mb-10 w-full md:w-1/2" }, { children: [_jsx(LocationBold, { data: location_1.label }, void 0),
                            _jsx(HorizontalDivisor, { marginTop: "9px", marginBottom: "16px", color: chosenTheme.color }, void 0),
                            _jsx(Address, { data: location_1.body }, void 0)] }), index));
                }
                index++;
            }
            var ulItem = (_jsx("ul", __assign({ className: oneKey + "row_" + i / columns + " w-full flex" }, { children: liArray }), oneKey + "_" + i / columns));
            ulArray.push(ulItem);
        }
        return ulArray;
    };
    return (_jsxs("div", __assign({ className: "directory-list relative min-h-screen w-full snap-center " + (chosenTheme.backgroundColor !== '#ffffff'
            ? 'pt-[104px] md:pt-[192px] lg:pt-[260px]'
            : 'pt-[64px] md:pt-[112px] lg:pt-[120px]') }, { children: [_jsx("div", __assign({ className: "absolute z-0 w-full top-0" }, { children: _jsx("svg", __assign({ className: "h-full w-full fill-current", style: { color: chosenTheme.backgroundColor }, viewBox: "0 0 1440 1022", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M0 1021.5h1440.63V192L0 0v1021.5z" }, void 0) }), void 0) }), void 0),
            _jsxs("div", __assign({ className: "directory-list-section relative min-h-screen w-full px-[24px] md:px-[92px] pb-8", style: chosenTheme }, { children: [_jsx("h5", __assign({ className: "directory-list__header pb-14 w-full", style: { color: chosenTheme.color } }, { children: headline }), void 0),
                    Object.keys(regions).map(function (oneKey) {
                        return (_jsxs("div", __assign({ className: "directory-list-region pb-8 md:pb-11 font-light" }, { children: [_jsx("p", __assign({ className: "directory-list-regionName" }, { children: oneKey }), void 0),
                                _jsx("div", __assign({ className: "directory-list-flexWrapper flex flex-col md:pt-12 pt-10" }, { children: renderList(regions[oneKey], oneKey) }), void 0)] }), oneKey));
                    })] }), void 0)] }), void 0));
};
export default DirectoryList;
DirectoryList.defaultProps = defaultProps;
